//@ts-nocheck
import React from "react";
import { CKEditor } from "ckeditor4-react";

const editorConfiguration = {
  extraAllowedContent: "video[*]{*}",
  filebrowserBrowseUrl: `/?app=admin&run=filemanager&page=dialog&type=2&editor=ckeditor&fldr=`,
  filebrowserUploadUrl: `/?app=admin&run=filemanager&page=dialog&type=2&editor=ckeditor&fldr=`,
  filebrowserImageBrowseUrl: `/?app=admin&run=filemanager&page=dialog&type=1&editor=ckeditor&fldr=`,
  language: "fa",
};

export default function Editor(props) {
  const { id, type, value, getValue } = props;

  function handleChange(evt) {
    getValue?.(evt.editor.getData());
  }

  return (
    <CKEditor
      initData={value}
      id={id}
      type={type}
      data={value}
      onChange={handleChange}
      // editorUrl="https://cdn.gandom.org/panel/v6/ckeditor/ckeditor.js"
      config={{
        ...editorConfiguration,
      }}
      extraPlugins={"video,plugins"}
    />
  );
}
